export const signaturePositions = [
  {
    key: "instructor_left",
    label: "Instrutor - Esquerda",
    page: "front",
    topMm: 151,
    leftMm: 38,
    widthMm: 52,
    heightMm: 18,
    zIndex: 5,
  },
  {
    key: "technical_center",
    label: "Responsável Técnico - Centro",
    page: "front",
    topMm: 151,
    leftMm: 112,
    widthMm: 52,
    heightMm: 18,
    zIndex: 5,
  },
  {
    key: "student_right",
    label: "Aluno - Direita",
    page: "front",
    topMm: 151,
    leftMm: 188,
    widthMm: 52,
    heightMm: 18,
    zIndex: 5,
  },
];

export function findSignaturePosition(key) {
  return signaturePositions.find((position) => position.key === key);
}

export function getDefaultSignaturePosition() {
  return signaturePositions[0];
}
